// Recovered compiled webpack factory 24431. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      MetadataBoundary: function () {
        return o;
      },
      OutletBoundary: function () {
        return s;
      },
      RootLayoutBoundary: function () {
        return l;
      },
      ViewportBoundary: function () {
        return i;
      },
    }));
  let n = r(68440),
    a = {
      [n.METADATA_BOUNDARY_NAME]: function (e) {
        let { children: t } = e;
        return t;
      },
      [n.VIEWPORT_BOUNDARY_NAME]: function (e) {
        let { children: t } = e;
        return t;
      },
      [n.OUTLET_BOUNDARY_NAME]: function (e) {
        let { children: t } = e;
        return t;
      },
      [n.ROOT_LAYOUT_BOUNDARY_NAME]: function (e) {
        let { children: t } = e;
        return t;
      },
    },
    o = a[n.METADATA_BOUNDARY_NAME.slice(0)],
    i = a[n.VIEWPORT_BOUNDARY_NAME.slice(0)],
    s = a[n.OUTLET_BOUNDARY_NAME.slice(0)],
    l = a[n.ROOT_LAYOUT_BOUNDARY_NAME.slice(0)];
}
